import { getDefaultExportFromCjs } from './_commonjsHelpers.mjs';
import { __require as requireClassnames } from '../node_modules/classnames/index.mjs';

var classnamesExports = requireClassnames();
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

export { classNames as default };
//# sourceMappingURL=index.mjs.map
